import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

const makeBannersActive = async (data: number[]) => {
	const response = await cmsClient.post<unknown>(
		"/homepage/admin/carouselbanner/publish/",
		data
	);

	return response.data;
};

const useMakeBannersActive = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		toast.success(
			<CustomToast type="Success" message="Banner(s) made active" />,
			{ hideProgressBar: true }
		);

		queryClient.invalidateQueries(["active-banners"]);
		queryClient.invalidateQueries(["banner-library"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong, try again" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(makeBannersActive, {
		onError,
		onSuccess,
	});

	return mutation;
};

export default useMakeBannersActive;
